import { render, staticRenderFns } from "./Diario.vue?vue&type=template&id=201a068a&scoped=true&"
import script from "./Diario.vue?vue&type=script&lang=js&"
export * from "./Diario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a068a",
  null
  
)

export default component.exports